import { cn } from '@bw/core';
import { Block } from '../../factories/types';
import { annotate } from '../../utils/annotate';
import { schemeToClass } from '../../utils/colorMap';
import { RichText } from '../../utils/rich-text/RichText';
import { ProductGridItem } from './ProductGridItem';
import styles from './ProductGridSection.module.scss';

export const ProductGridSection: Block<'productGridSection'> = ({
	data,
	render,
}) => {
	const {
		fields: { title, items, colorScheme, positioning = 'Center' },
	} = data;

	return (
		<section
			className={cn(styles.productGrid, schemeToClass(colorScheme))}
			{...annotate(data)}
		>
			{title ? (
				<div className={styles.title} {...annotate(data, 'title')}>
					<RichText document={title} />
				</div>
			) : null}

			{items ? (
				<div
					className={cn(
						styles.items,
						positioning === 'Center' && styles.center,
						positioning === 'Left' && styles.left
					)}
				>
					{render(items, { template: ProductGridItem })}
				</div>
			) : null}
		</section>
	);
};
